import { FC, useEffect } from 'react';
import { Box, Container, Divider, Stack } from '@mui/material';
import { LoadingBackdrop } from '../../components/loading.backdrop.tsx';
import { Form, Formik } from 'formik';
import { useQuestionsQuery } from '../../graphql/generated/operations/questions.ts';
import { QuestionType } from '../../graphql/generated/graphql.ts';
import { Question } from '../../components/question/question.tsx';
import { SubmitButton } from '../../components/forms/submit.button.tsx';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { useUpdateUserMotivatedMutation } from '../../graphql/generated/operations/user.ts';
import { Paths } from '../../constants/paths.ts';
import { trackEvent } from '../../utils/analytics.ts';

export const MotivationQuestionsPage: FC = () => {
  const navigate = useNavigate();
  const [updateMotivation, { data: saved, loading: saving }] = useUpdateUserMotivatedMutation();
  const { data, loading } = useQuestionsQuery({
    variables: {
      type: QuestionType.Motivation
    }
  });

  useEffect(() => {
    if (saved) {
      navigate(Paths.TUTORIAL);
    }
  }, [saved]);

  useEffect(() => {
    if (data?.questions.length === 0) {
      navigate(Paths.TUTORIAL);
    }
  }, []);

  if (loading || saving) {
    return <LoadingBackdrop />;
  }
  return (
    <Container sx={{ mt: 3 }} maxWidth="md">
      <Formik
        validationSchema={yup.object(
          data?.questions.reduce((acc: any, question) => {
            acc[question._id] = yup.string().required('Required');
            return acc;
          }, {})
        )}
        initialValues={{}}
        onSubmit={async (values: any) => {
          trackEvent('motivation_questions_submit');
          await updateMotivation({
            variables: {
              questions: Object.keys(values).map((key: string) => ({
                questionId: key,
                response: values[key].toString()
              }))
            }
          });
        }}
      >
        <Form>
          {data?.questions.map((question, index) => (
            <Stack key={question._id} spacing={2}>
              <Question question={question} />
              {index !== data?.questions.length && (
                <Box sx={{ mb: 1 }}>
                  <Divider />
                </Box>
              )}
            </Stack>
          ))}
          <SubmitButton>Next</SubmitButton>
        </Form>
      </Formik>
    </Container>
  );
};
